import { render, staticRenderFns } from "./upload-video.vue?vue&type=template&id=6a069ff0&scoped=true&"
import script from "./upload-video.vue?vue&type=script&lang=js&"
export * from "./upload-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a069ff0",
  null
  
)

export default component.exports